import { inicializarVueNoElemento } from '@App/VueHooks'

class ReflinksVue extends HTMLElement {
    connectedCallback() {
        if (this.hasAttribute('vue-initialized')) return
        this.setAttribute('vue-initialized', 'true')

        inicializarVueNoElemento(this)
    }
}

if (!window.customElements.get('reflinks-vue')) {
    window.customElements.define('reflinks-vue', ReflinksVue)
}
